
export interface ContactEmail {
    id: number;
    email: string;
}

export interface ContactPhoneNumber {
    id: number;
    country_code: number;
    phone_number: string;
    phone_full: string;
}

export interface ContactTag {
    id?: number;
    name?: string;
    code?: string;
}

export interface ContactDeviceMap {
    id?: number;
    device_id?: string;
    device_name?: string;
    last_seen?: string;
}

export interface Contact {
    id: number;
    name: string;
    tags: ContactTag[] | string;
    trusted_person_id: number | null;
    emails: ContactEmail[];
    phone_numbers: ContactPhoneNumber[];
    blocked: boolean;
    public_key: string | null;
    risk: string | null;
    licensed: boolean | null;
    access: boolean;
    device_maps: ContactDeviceMap[];
}

export interface ContactSelect {
    id: number;
    name: string;
    type: ContactType;
}

export enum ContactType {
    PERSON = 'person',
    CONTACT = 'contact'
}

// Activity types for chat functionality
export interface Activity {
    id: string;
    type: string;
    from_type: string;
    from_id: number;
    from: string;
    to_type: string;
    to_id: number;
    to: string;
    message: any | null;
    created_at: string;
}

export interface ActivityFeedResponse {
    data: Activity[];
    meta?: {
        total: number;
        per_page: number;
        current_page: number;
        from: number;
        to: number;
        last_page: number;
    };
    additional?: any | null;
    query_id?: string;
    response_time?: number;
    api_version?: number;
}
